import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { useNotification, useUserData } from '../../../../../hooks'
import { toRequestSelectItem } from '../../../../Request'
import {
  createTask,
  TASK_FORM_INITIAL_VALUES,
  TASK_FORM_MANAGER_FIELD_NAME,
  TASK_FORM_PHASE_FIELD_NAME,
  TASK_FORM_SERVICE_REQUEST_FIELD_NAME,
  TaskFormModal,
} from '../../../../Task'
import { toUserSelectItem } from '../../../../User'
import {
  REQUEST_PROFILE_TAB_ACTIVITIES,
  REQUEST_PROFILE_TAB_DOCUMENTS,
} from '../../../RequestProfile.constants'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { getActivityCreationSuccessNotificationProps } from '../../RequestProfileTabActivities.utils'
import { useRequestProfileTabActivitiesContext } from '../useRequestProfileTabActivitiesContext'

export function useAddActivityModal({ phase } = EMPTY_OBJECT) {
  const { t } = useTranslation()

  const { closeModal, handleReload, setModal } =
    useRequestProfileTabActivitiesContext()

  const { handleLoadCounters, handleReloadOpenActivities, requestData } =
    useRequestProfileContext()

  const { handleAddNotification } = useNotification()

  const currentUser = useUserData()

  const phaseId = phase?.id

  function handleSuccess(task) {
    closeModal()
    handleAddNotification(
      getActivityCreationSuccessNotificationProps({ ...task, t })
    )
    handleReload(phaseId ? { phaseIds: [phaseId] } : undefined)
    handleReloadOpenActivities?.()
    handleLoadCounters?.([
      REQUEST_PROFILE_TAB_ACTIVITIES,
      REQUEST_PROFILE_TAB_DOCUMENTS,
    ])
  }

  function handleAddActivity() {
    setModal(
      <TaskFormModal
        fieldsProps={{
          hidePhase: Boolean(phaseId),
          hideServiceRequest: true,
        }}
        initialValues={{
          ...TASK_FORM_INITIAL_VALUES,
          ...(phaseId ? { [TASK_FORM_PHASE_FIELD_NAME]: phaseId } : null),
          ...(currentUser
            ? { [TASK_FORM_MANAGER_FIELD_NAME]: toUserSelectItem(currentUser) }
            : null),
          [TASK_FORM_SERVICE_REQUEST_FIELD_NAME]: requestData
            ? toRequestSelectItem(requestData)
            : null,
        }}
        onClose={closeModal}
        onSubmit={createTask}
        onSuccess={handleSuccess}
      />
    )
  }

  return handleAddActivity
}
